module.exports = __webpack_public_path__ + "static/media/fh_my.4c83b632.png";